<script lang="ts" setup>
import vuIcon from '@ds/vuekit/src/components/vu-icon.vue';
import vuBtn from '@ds/vuekit/src/components/vu-btn.vue';

import { useTranslations } from '~/composables/translations';
import { onBeforeUnmount, onMounted, ref } from 'vue';

interface Props {
  isSubmit?: boolean;
  disabledNext?: boolean;
  disabledBack?: boolean;
}

let observer: IntersectionObserver;
const container = ref<HTMLDivElement>();
const emit = defineEmits(['back', 'next']);

const { $i18n } = useTranslations('components/lab/back_and_next_btn');
const { $i18n: $i18nCommon } = useTranslations('common');

const props = withDefaults(defineProps<Props>(), {
  isSubmit: false,
  disabledNext: false,
  disabledBack: false,
});

onMounted(() => {
  if (!container.value) {
    return;
  }

  observer = new IntersectionObserver(
    (entries) => {
      if (
        entries[0].boundingClientRect.bottom < window.innerHeight &&
        entries[0].boundingClientRect.bottom > 300
      ) {
        return container.value?.classList.add('pull-to-left');
      }

      container.value?.classList.remove('pull-to-left');
    },
    {
      threshold: 1,
    },
  );

  observer.observe(container.value);
});

onBeforeUnmount(() => {
  observer?.disconnect();
});
</script>
<template>
  <div
    class="flex align-items-center grid-gap-10px justify-end back-next-bnt-container"
    ref="container"
  >
    <vu-btn @click="emit('back')" :disabled="props.disabledBack" class="back">
      <vu-icon icon="chevron-left" />
      {{ $i18nCommon('Back') }}
    </vu-btn>
    <vu-btn
      v-if="!props.isSubmit"
      @click="emit('next')"
      class="next"
      :disabled="props.disabledNext"
    >
      {{ $i18nCommon('Next') }}
      <vu-icon icon="chevron-right" />
    </vu-btn>
    <vu-btn
      v-if="props.isSubmit"
      :disabled="props.disabledNext"
      @click="emit('next')"
      class="next submit"
      color="primary"
    >
      {{ $i18n('submitMyMakeLab') }}
    </vu-btn>
  </div>
</template>
<style lang="scss" scoped>
@use '/assets/scss/variables' as variables;

.next {
  .fonticon {
    float: unset;
    margin: 0px 0px 0px 14px;
  }
}
.back-next-bnt-container {
  transition: transform 0.3s ease;
}

@include variables.for-xs {
  .next,
  .back {
    width: 100%;
  }
}

.pull-to-left {
  @media (max-width: 1276px) {
    transform: translateX(-50px);
  }
  @include variables.for-xs {
    transform: unset;
  }
}
</style>
